import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberPapers } from "@api/members/papers/routeType";

const { key, getPath } = getApi("members.papers.getAll");

type IExtractedRouteType = IMemberPapers["paperCollectionRetrieve"];

export type IGetAllMemberPapers = IPickCollectionQuery<IExtractedRouteType>;

const getAllMemberPapers: Fetcher<
  IGetAllMemberPapers["response"],
  IGetAllMemberPapers["variables"]
> = ({ memberId, ...params }) => {
  return axiosClient.get(getPath({ memberId }), { params });
};

export const useGetAllMemberPapers = createQuery({
  queryKey: [key],
  fetcher: getAllMemberPapers,
});
